import { ActionType } from "typesafe-actions";

import { TripClass } from "../common_types";

import * as actions from "./actions";

export type IntegrationErrorsAction = ActionType<typeof actions>;

export enum IntegrationErrorsActionTypes {
  TABLE_FETCH_REQUEST = "@IntegrationErrors/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@IntegrationErrors/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@IntegrationErrors/TABLE_FETCH_ERROR",

  CHART_FETCH_REQUEST = "@IntegrationErrors/CHART_FETCH_REQUEST",
  CHART_FETCH_SUCCESS = "@IntegrationErrors/CHART_FETCH_SUCCESS",
  CHART_FETCH_ERROR = "@IntegrationErrors/CHART_FETCH_ERROR",

  SAMPLES_FETCH_REQUEST = "@IntegrationErrors/SAMPLES_FETCH_REQUEST",
  SAMPLES_FETCH_SUCCESS = "@IntegrationErrors/SAMPLES_FETCH_SUCCESS",
  SAMPLES_FETCH_ERROR = "@IntegrationErrors/SAMPLES_FETCH_ERROR",
}

export type IntegrationErrorType =
  | "unknown_error"
  | "internal_error"
  | "parse_error"
  | "timeout_error"
  | "partner_error"
  | "request_error";

export interface IntegrationErrorPayload {
  errorsType?: IntegrationErrorType[];
}

export interface IntegrationErrorSample {
  searchId: string;
  origin: string;
  destination: string;
  departureDate: string;
  returnDate: string | null;
  tripClass: TripClass;
  adults: number;
  children: number;
  infants: number;
  market: string;
  currency: string;
  locale: string;
}

export interface IntegrationErrorsTypeSample {
  unknownError: IntegrationErrorSample | null;
  internalError: IntegrationErrorSample | null;
  parseError: IntegrationErrorSample | null;
  timeoutError: IntegrationErrorSample | null;
  partnerError: IntegrationErrorSample | null;
  requestError: IntegrationErrorSample | null;
}

export interface IntegrationErrorItem {
  timestamp: string;
  errorType: IntegrationErrorType;
  errors: number;
  percentByTotalErrors: number;
  percentByTotalSearches: number;
}

export interface IntegrationErrorChartItem {
  timestamp: string;
  totalErrors: number;
  totalSearches: number;
  unknownErrors: number;
  internalErrors: number;
  parseErrors: number;
  timeoutErrors: number;
  partnerErrors: number;
  requestErrors: number;
}

export interface IntegrationErrorsState {
  count: number;
  items: IntegrationErrorItem[];
  dataIsLoading: boolean;

  chartItems: IntegrationErrorChartItem[];
  chartDataIsLoading: boolean;

  samples: IntegrationErrorsTypeSample;
  samplesIsLoading: boolean;
}
